import { jsx as _jsx } from "react/jsx-runtime";
import { translate } from '../../../strings/i18n';
import { CustomDrawerHeader } from '../subcomponents';
var CardDetails = function (_a) {
    var _b = _a.productName, productName = _b === void 0 ? '' : _b, _c = _a.cardLast4, cardLast4 = _c === void 0 ? '' : _c, _d = _a.cardImage, cardImage = _d === void 0 ? '' : _d;
    return (_jsx(CustomDrawerHeader, { title: productName, subtitle: translate('mocks.accountEnding', {
            accountLast4: cardLast4
        }), img: cardImage, alt: "card-preview" }));
};
export default CardDetails;
